// src/components/FormikInput.js

import React from "react"
import { FormGroup, Label, Input, FormFeedback } from "reactstrap"

const FormikInput = ({
  label,
  name,
  max = 255,
  type = "text",
  placeholder,
  formik,
  onChange,
  onBlur,
  mask, // Opcional: si usas InputMask
  showCharacterCounter = false,
  isLoading,
  ...props
}) => {
  return (
    <FormGroup>
      <Label htmlFor={name}>{label}</Label>
      {!isLoading ? (
        <>
          <Input
            type={type}
            name={name}
            id={name}
            placeholder={placeholder}
            value={formik.values[name]}
            onChange={onChange || formik.handleChange}
            onBlur={onBlur || formik.handleBlur}
            invalid={formik.touched[name] && !!formik.errors[name]}
            maxLength={max} // Limita la entrada a max caracteres
            autoComplete="off"
            {...props}
          />{" "}
          {showCharacterCounter ? (
            <div className="text-end">
              {formik.values[name].length}/{max}
            </div>
          ) : null}
        </>
      ) : (
        <div>
          <p aria-hidden="true" className="mt-2">
            <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
          </p>
        </div>
      )}
      {formik.touched[name] && formik.errors[name] && (
        <FormFeedback>{formik.errors[name]}</FormFeedback>
      )}
    </FormGroup>
  )
}

export default FormikInput
